<template>
	<div class="return-country-select text-center">
		<label for="return-country-select" style="display:block;"><slot name="label-text"></slot></label>
		<select id="return-country-select" @change="stateChanged($event.target.value)" style="max-width:300px;margin-bottom:20px;">
            <option :value="index" :selected="country.link === selectedCountry.link" v-for="(country, index) in countryList" :key="index">
            	{{ country.name }}
        	</option>
        </select>
		<br>
		<a id="dhl-return-button" class="btn btn-primary moz-txt-link-freetext" :href="selectedCountry.link" target="_blank"><slot name="label-text"></slot> ({{ selectedCountry.name }})</a>
	</div>
</template>

<script>
export default {
    name: "return-country-select",

	props: {
		countryList:
        {
            type: Array,
            required: true
        }
	},
    data()
    {
        return {
            selectedCountry: false
        };
    },
	mounted()
	{
		this.selectedCountry = this.countryList[0];
	},
	methods:
	{
		stateChanged(index)
		{
			this.selectedCountry = this.countryList[index];
		}
	}
};
</script>